<router-outlet />
<app-sidebar-drawer></app-sidebar-drawer>
<app-mobile-tab-bar></app-mobile-tab-bar>
@if (showLaunchTransition) {
  <app-sky-transition
    eyebrow="Welcome aboard"
    [context]="launchSkyContext"
    (closed)="closeLaunchTransition()" />
}
